(ns frontend.view.components.timeline.entry.company-create
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [common.localization :as loc]
            [frontend.state.current-session :as session]))

(defn title-generator [entry]
  (let [op (-> entry :audit/op)
        name (->> entry
                  :audit/target
                  (get @session/entities)
                  :asset/name)]
    (loc/tr op [name])))

(defmethod te/timeline-entry-view :op.company/create [{entry :entry :as arg}]
  [default/timeline-item-view entry title-generator default/body-generator default/timestamp-generator])
